import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IInventionAssistantState {
  name: string;
}

const initialState: IInventionAssistantState = {
  name: '',
};

const inventionAssistantSlice = createSlice({
  name: 'inventionAssistant',
  initialState,
  reducers: {
    setInventionAssistant: (state, action: PayloadAction<IInventionAssistantState>) => {
      state.name = action.payload.name;
    },
    setInventionAssistantName: (state, action: PayloadAction<string>) => {
      state.name = action.payload;
    },
  },
});

export default inventionAssistantSlice.reducer;

export const { setInventionAssistant, setInventionAssistantName } = inventionAssistantSlice.actions;
